module.exports = __webpack_public_path__ + "components/bookings-online-payment-method/static/visa-e1edbf7df8b28a8d1baf158527cecfed.svg";